<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_6">Thank you for supporting authors and literacy by purchasing this book. Want to add more gripping reads to your library? As the author of more than a dozen award-winning and bestselling books, you can find all of Pamela Crane’s works on her website at <a class="text_" href="http://www.pamelacrane.com/" target="_blank">www.pamelacrane.com</a>. </p>
<p class="block_6"> </p>
<p class="block_2" id="calibre_pb_4"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?1b4eac07